import CurrentUserUseCase from "./CurrentUserUseCase";
import LogoutUserUseCase from "./LogoutUserUseCase";
import GetUserByIdUseCase from "./GetUserByIdUseCase";
import ValidAuthenticationUseCase from "./ValidAuthenticationUseCase";
import userRepository from "../5_Infrastructure/factory";
import SetUserRoleActiveUseCase from "./SetUserRoleActiveUseCase";
import CleanUserRoleActiveUseCase from "./CleanUserRoleActiveUseCase";
import CleanUserSupportIdActiveUseCase from "./CleanUserSupportIdActiveUseCase";

export const currentUserUseCase = () => new CurrentUserUseCase(userRepository);

export const logoutUserUseCase = () => new LogoutUserUseCase(userRepository);

export const getUserByIdUseCase = () => new GetUserByIdUseCase(userRepository);

export const setUserRoleActiveUseCase = () =>
  new SetUserRoleActiveUseCase(userRepository);

export const cleanUserSupportIdActiveUseCase = () =>
  new CleanUserSupportIdActiveUseCase(userRepository);

export const cleanUserRoleActiveUseCase = () =>
  new CleanUserRoleActiveUseCase(userRepository);

export const validAuthenticationUseCase = () =>
  new ValidAuthenticationUseCase(userRepository);